import { render } from "./reset-password.vue?vue&type=template&id=6125aeda"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/home/reset-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6125aeda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6125aeda', __exports__)) {
    console.log('reload')
    api.reload('6125aeda', __exports__)
  }
  
  module.hot.accept("./reset-password.vue?vue&type=template&id=6125aeda", () => {
    console.log('re-render')
    api.rerender('6125aeda', render)
  })

}


export default __exports__